import { render, staticRenderFns } from "./ESGStrategy.vue?vue&type=template&id=e0ff6566&scoped=true"
import script from "./ESGStrategy.vue?vue&type=script&lang=js"
export * from "./ESGStrategy.vue?vue&type=script&lang=js"
import style0 from "./ESGStrategy.vue?vue&type=style&index=0&id=e0ff6566&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0ff6566",
  null
  
)

export default component.exports